import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { utils, List } from '@costar/theme-ui';
import React, { useMemo } from 'react';
import renderOptions from './render-options.esm.js';
import { SelectKeyNavContextProvider } from './select-key-nav-context.esm.js';

var DefaultPopoverContent = function DefaultPopoverContent(props) {
  var renderItem = props.renderItem,
    showSelectionCheckbox = props.showSelectionCheckbox,
    listProps = props.listProps,
    isMultiSelect = props.isMultiSelect,
    extendedContent = props.extendedContent,
    extendedContentTop = props.extendedContentTop,
    options = props.options,
    selection = props.selection,
    handleClose = props.handleClose,
    selectionClick = props.selectionClick;
  var _listProps = listProps !== null && listProps !== void 0 ? listProps : utils.EMPTY_OBJECT;
  var content = useMemo(function () {
    return renderOptions(options, renderItem, selection, selectionClick, handleClose, extendedContent, extendedContentTop);
  }, [extendedContent, extendedContentTop, handleClose, options, renderItem, selection, selectionClick]);
  return /*#__PURE__*/React.createElement(SelectKeyNavContextProvider, {
    options: options,
    selectionClick: selectionClick,
    handleClose: handleClose,
    isMultiSelect: isMultiSelect
  }, /*#__PURE__*/React.createElement(List, _extends({
    variant: showSelectionCheckbox ? 'select-list-show-checkbox' : 'select-list'
  }, _listProps), content));
};
function defaultRenderPopoverContent (renderItem, showSelectionCheckbox, listProps, isMultiSelect, extendedContent, extendedContentTop) {
  // standard overridable contract to render content of popover
  return function PopoverContent(options, selection, handleClose, selectionClick) {
    return /*#__PURE__*/React.createElement(DefaultPopoverContent, {
      renderItem: renderItem,
      showSelectionCheckbox: showSelectionCheckbox,
      listProps: listProps,
      isMultiSelect: isMultiSelect,
      extendedContent: extendedContent,
      extendedContentTop: extendedContentTop,
      options: options,
      selection: selection,
      handleClose: handleClose,
      selectionClick: selectionClick
    });
  };
}

export default defaultRenderPopoverContent;
//# sourceMappingURL=render-popover-content.esm.js.map
